var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.isEditing
      ? _c(
          "div",
          { staticClass: "editor-heading" },
          [
            _c("input-textarea", {
              attrs: {
                variant: "standardInput",
                inputName: "body",
                inputLabel: "Body:",
                inputPlaceholder: "Body",
                inputValue: _vm.getEditedParts.body
              },
              on: { fieldUpdate: _vm.updateContentField }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "text-center" },
              [
                _c("input-button", {
                  attrs: {
                    variant: "standardInput",
                    btnStyle: "ok-style",
                    inputPlaceholder: _vm.$t("Button.save"),
                    smaller: "",
                    boxy: ""
                  },
                  on: {
                    click: function($event) {
                      return _vm.updateContent()
                    }
                  }
                }),
                _vm._v(" "),
                _c("input-button", {
                  attrs: {
                    variant: "standardInput",
                    btnStyle: "default-style",
                    inputPlaceholder: _vm.$t("Button.cancel"),
                    smaller: "",
                    boxy: ""
                  },
                  on: {
                    click: function($event) {
                      return _vm.toggleEditContent(false)
                    }
                  }
                })
              ],
              1
            )
          ],
          1
        )
      : _c(
          "div",
          [
            _c(
              "button",
              {
                staticClass: "mb-2",
                on: {
                  click: function($event) {
                    return _vm.toggleEditContent(true)
                  }
                }
              },
              [_c("icon", { attrs: { name: "pencil" } })],
              1
            ),
            _vm._v(" "),
            _vm._l(_vm.displayParts, function(p) {
              return _c(
                p.tag,
                { key: p.name, tag: "component", staticClass: "content-line" },
                [
                  _vm._v(
                    "\n\n      " + _vm._s(_vm.getEditedParts[p.name]) + "\n    "
                  )
                ]
              )
            })
          ],
          2
        )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-74dd4017", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74dd4017","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/service/administration/editor/PageEditor.vue
// module id = null
// module chunks = 